<button
  class="primary-btn loadingButton confirm"
  [ngClass]="{ isLoading: isLoading, disabled: disabled }"
  [disabled]="disabled"
  (click)="handleClick($event)"
  >
  <span>{{ text }}</span>
  @if (isLoading) {
    <div class="loadingAnimation"></div>
  }
</button>
